module.exports = "/fast-coin/img/coin/anim/out_1/out_1_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_002.png
// module id = 2298
// module chunks = 5